import { SetStateAction, useEffect, useState } from 'react'
import { CargoItemInterface, PointItemInterface } from '../../../../types/interfaces'
import { v4 } from 'uuid'

export const usePointForm = (
  addresses: boolean,
  topData: CargoItemInterface,
  intercity: boolean,
  setTopData: React.Dispatch<SetStateAction<CargoItemInterface>>,
  initialData?: PointItemInterface[],
  isRoute?: boolean,
) => {
  const pointDataInitialValue: PointItemInterface[] = isRoute
    ? [
        {
          id: `a${v4()}`,
          sequence: 1,
          city: {
            value: '',
            latitude: undefined,
            longitude: undefined,
            isDirty: false,
            notValid: true,
          },
          address: {
            value: '',
            latitude: undefined,
            longitude: undefined,
            isDirty: false,
            notValid: true,
          },
        },
        {
          id: `a${v4()}`,
          sequence: 2,
          city: {
            value: '',
            latitude: undefined,
            longitude: undefined,
            isDirty: false,
            notValid: true,
          },
          address: {
            value: '',
            latitude: undefined,
            longitude: undefined,
            isDirty: false,
            notValid: true,
          },
        },
      ]
    : [
        {
          id: `a${v4()}`,
          sequence: 1,
          city: {
            value: '',
            latitude: undefined,
            longitude: undefined,
            isDirty: false,
            notValid: true,
          },
          address: {
            value: '',
            latitude: undefined,
            longitude: undefined,
            isDirty: false,
            notValid: true,
          },
        },
      ]

  const [data, setData] = useState<PointItemInterface[]>(
    topData.points && topData.points.length > 0
      ? structuredClone(topData.points)
      : initialData
      ? structuredClone(initialData)
      : structuredClone(pointDataInitialValue),
  )

  const [currentPoint, setCurrentPoint] = useState<PointItemInterface>()
  const sortPoints = (a: PointItemInterface, b: PointItemInterface) => {
    if (a.sequence > b.sequence) {
      return 1
    } else {
      return -1
    }
  }

  const addPoint = (pointItem: PointItemInterface) => {
    setTopData((prev) => ({ ...prev, route: undefined })) //erasing route  
    const tempData = [
      ...data.map((point) => {
        if (point.sequence > pointItem.sequence) {
          return { ...point, sequence: point.sequence + 1 }
        }
        return point
      }),
    ].toSpliced(pointItem.sequence, 0, {
      id: `a${v4()}`,
      sequence: pointItem.sequence + 1,
      city: {
        value: '',
        latitude: undefined,
        longitude: undefined,
        isDirty: false,
        notValid: true,
      },
      address: {
        value: '',
        latitude: undefined,
        longitude: undefined,
        isDirty: false,
        notValid: true,
      },
    })

    setData(tempData)
  }

  const removePoint = (pointItem: PointItemInterface) => {
    setTopData((prev) => ({ ...prev, route: undefined }))
    const tempData = [
      ...data
        .filter((point) => point.sequence !== pointItem.sequence)
        .map((point) => {
          if (point.sequence > pointItem.sequence) {
            return { ...point, sequence: point.sequence - 1 }
          }
          return point
        }),
    ]

    setData(tempData)
  }

  const pointUp = (pointItem: PointItemInterface) => {
    setTopData((prev) => ({ ...prev, route: undefined }))
    const tempData = [
      ...data.map((point) => {
        if (point.sequence === pointItem.sequence) {
          return { ...point, sequence: point.sequence - 1 }
        }
        if (point.sequence === pointItem.sequence - 1) {
          return { ...point, sequence: pointItem.sequence }
        }
        return point
      }),
    ]
    setData(tempData)
  }

  const pointDown = (pointItem: PointItemInterface) => {
    setTopData((prev) => ({ ...prev, route: undefined }))
    const tempData = [
      ...data.map((point) => {
        if (point.sequence === pointItem.sequence) {
          return { ...point, sequence: point.sequence + 1 }
        }
        if (point.sequence === pointItem.sequence + 1) {
          return { ...point, sequence: pointItem.sequence }
        }
        return point
      }),
    ]
    setData(tempData)
  }

  const dragStartHandler = (e: React.DragEvent<HTMLDivElement>, pointItem: PointItemInterface) => {
    setCurrentPoint(pointItem)
  }

  function dragLeaveHandler(e: React.DragEvent<HTMLDivElement>) {
    e.preventDefault()
  }

  const dragEndHandler = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault()
  }

  const dragOverHandler = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault()
  }

  const dropHandler = (e: React.DragEvent<HTMLDivElement>, pointItem: PointItemInterface) => {
    setTopData((prev) => ({ ...prev, route: undefined }))
    e.preventDefault()
    const tempData = [
      ...data.map((point) => {
        if (currentPoint && point.id === pointItem.id) {
          return { ...point, sequence: currentPoint.sequence }
        }
        if (currentPoint && point.id === currentPoint.id) {
          return { ...point, sequence: pointItem.sequence }
        }
        return point
      }),
    ]
    setData(tempData)
  }

  const handleFormBlur = (index: number, event: React.ChangeEvent<HTMLInputElement>) => {
    let tempData = [...data]
    tempData[index][event.target.name].isDirty = true
    setData(tempData)
  }

  useEffect(() => {
    setData(
      topData.points && topData.points.length > 0
        ? structuredClone(topData.points)
        : initialData
        ? structuredClone(initialData)
        : structuredClone(pointDataInitialValue),
    )
  }, [isRoute, addresses, intercity])

  useEffect(() => {    
    data.find((el) => el.city.value) && setTopData((prev) => ({ ...prev, points: [...data] }))
  }, [data])



  return {
    data,
    setData,
    sortPoints,
    addPoint,
    removePoint,
    pointUp,
    pointDown,
    dragStartHandler,
    dragLeaveHandler,
    dragEndHandler,
    dragOverHandler,
    dropHandler,
    handleFormBlur,
  }
}
